import Keycloak from 'keycloak-js';

type KeycloakDirectGrantSuccessResponse = {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in: number;
  token_type: string;
  'not-before-policy': number;
  session_state: string;
  scope: string;
};

type KeycloakErrorCode =
  | 'invalid_request'
  | 'unsupported_grant_type'
  | 'invalid_grant';

type KeycloakDirectGrantErrorResponse = {
  error: KeycloakErrorCode;
  error_description: string;
};

type KeycloakDirectGrantResponse =
  | KeycloakDirectGrantSuccessResponse
  | KeycloakDirectGrantErrorResponse;

class AuthError extends Error {
  constructor(public errorCode: KeycloakErrorCode) {
    super(errorCode);
  }
}

const keycloakAuthUrl = (keycloak: Keycloak) =>
  `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/token`;

const login =
  (keycloak: Keycloak) => async (username: string, password: string) => {
    const response = await fetch(keycloakAuthUrl(keycloak), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        username,
        password,
        client_id: `${keycloak.clientId}`,
        grant_type: 'password',
      }),
    });

    const data = (await response.json()) as KeycloakDirectGrantResponse;
    if ('error' in data) {
      throw new AuthError(data.error);
    }

    await keycloak.init({
      token: data.access_token,
      refreshToken: data.refresh_token,
      checkLoginIframe: false,
      timeSkew: 1,
    });
  };

export { login, AuthError };
